import { styled } from "@mui/material/styles";
import React from "react";
import Rating from "@mui/material/Rating";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAltOutlined";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";

const StyledRating = styled(Rating)(() => ({
  "& .MuiRating-iconEmpty .MuiSvgIcon-root": {
    color: "#FCD6B4",
    fontSize: "35px !important",
    marginInline: "5px",
  },
}));

const customIcons = {
  1: {
    icon: (
      <SentimentVeryDissatisfiedIcon
        color="error"
        sx={{ fontSize: "35px !important", marginInline: "5px" }}
      />
    ),
    label: "Very Dissatisfied",
  },
  2: {
    icon: (
      <SentimentDissatisfiedIcon
        color="error"
        sx={{ fontSize: "35px !important", marginInline: "5px" }}
      />
    ),
    label: "Dissatisfied",
  },
  3: {
    icon: (
      <SentimentSatisfiedIcon
        color="warning"
        sx={{ fontSize: "35px !important", marginInline: "5px" }}
      />
    ),
    label: "Neutral",
  },
  4: {
    icon: (
      <SentimentSatisfiedAltIcon
        color="success"
        sx={{ fontSize: "35px !important", marginInline: "5px" }}
      />
    ),
    label: "Satisfied",
  },
  5: {
    icon: (
      <SentimentVerySatisfiedIcon
        color="success"
        sx={{ fontSize: "35px !important", marginInline: "5px" }}
      />
    ),
    label: "Very Satisfied",
  },
};

function IconContainer(props) {
  const { value, ...other } = props;
  return (
    <span {...other} style={{ position: "relative" }}>
      {customIcons[value].icon}
    </span>
  );
}

const CustomRating = ({ value, handleChagne }) => {
  return (
    <StyledRating
      onChange={handleChagne}
      value={value ? value : ""}
      name="highlight-selected-only"
      IconContainerComponent={IconContainer}
      getLabelText={(value) => customIcons[value].label}
      highlightSelectedOnly
    />
  );
};

export default CustomRating;
